import React, { useState } from 'react';
import { Button, Divider, Sidebar } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStageFormData } from './issues-slice';
import { fetchDocumentData } from '../document/documents-slice';
import { FormattedMessage, useIntl } from 'react-intl';
import CloseIcon from './CloseIcon';
import { useNavigate } from 'react-router-dom';

const prefix = 'rejectSignatureSuccess';

export default function RejectSignatureSuccess(props) {
  const [showModal, setShowModal] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const type = props.type;
  const itemType = props.itemType;
  const handleSidebarClose = props.handleSidebarClose;

  const itemAssignmentCode = useSelector((state) => state.auth.user.itemAssignmentCode);

  const handleApproval = () => {
    if (itemType === 'document') {
      dispatch(fetchDocumentData({ itemAssignmentCode, navigate }));
    } else {
      dispatch(fetchStageFormData({ itemAssignmentCode, navigate }));
    }
    handleSidebarClose();
    setShowModal(false);
  };

  const handleClose = () => {
    if (itemType === 'document') {
      dispatch(fetchDocumentData({ itemAssignmentCode, navigate }));
    } else {
      dispatch(fetchStageFormData({ itemAssignmentCode, navigate }));
    }
    handleSidebarClose();
    setShowModal(false);
  };

  const intl = useIntl();
  const translatedIssueType = intl.formatMessage({ id: `issueType.${type}`, defaultMessage: `${type}` });

  return (
    <div>
      <Sidebar animation="overlay" direction="right" width="very wide" visible={showModal} className="side-bar">
        <CloseIcon handleClose={handleClose} />
        <div className="signature-result-sidebar">
          <div className="header">
            <FormattedMessage
              id={`${prefix}.successfulRejection`}
              defaultMessage={`You have successfully rejected and signed your ${translatedIssueType}`}
              values={{ translatedIssueType }}
            />
          </div>
          <div className="sub-header">
            <FormattedMessage
              id={`${prefix}.${itemType ? 'documentsNotify' : 'notify'}`}
              defaultMessage="All stage assignees will be notified."
            />
          </div>
          <Divider hidden />
          <Button className="ui green button view-button" onClick={handleApproval}>
            <FormattedMessage
              id={`${prefix}.view`}
              defaultMessage={`View ${translatedIssueType}`}
              values={{ translatedIssueType }}
            />
          </Button>
        </div>
      </Sidebar>
    </div>
  );
}
